<template>
  <div class="item-row" v-if="model !== null">
    <div class="item-row__header">
      <div class="item-row__header--article">
        <v-btn
          elevation="0"
          rounded          
          dark
          outlined
          text
          x-small
          color="#1b99a7"
          :title="articleHeading"
          @click.stop.prevent="openItemPage"
          >
          {{ articleHeading }}
        </v-btn>
        
      </div>
      <div class="item-row__header--telegram" 
          v-if="kisoftEnabled">
        <v-btn
          elevation="0"
          rounded
          fab
          dark
          outlined
          text
          x-small
          color="white"
          title="view KiSoft telegram"
          @click.stop.prevent="showKisoftTelegram"
          >
          KI
        </v-btn>
      </div>
    </div>
    <div class="item-row__body">
        <template v-if="bundles.length > 0">
          <ItemBundle :bundle="bundle" v-for="(bundle, bundleIndex) in bundles" :key="bundleIndex" @redirectToItem="openItemPage"/>
        </template>
        <template v-else>
          <span>{{ $t('NO-ITEM-BUNDLES') }}</span>
        </template>
    </div>
  </div>
</template>

<script>
  import {cloneDeep} from 'lodash';
  import ItemBundle from './ItemBundle.vue';
  export default {
    name: 'ItemRow',
    components: {ItemBundle},
    props: {
      item: {
        type: Object,
      }
    },
    data(){
      return {
        model: null
      }
    },
    created(){

    },
    watch: {
      item:{
        handler(value){
          this.init();
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      kisoftEnabled(){
        if(!this.model) return false;
        return this.model.kisoftTelegram;
      },
      articleHeading(){
        if(!this.model) return '';
        let name = this.model.name;
        if(this.model.articleNo){
          if(name){
            name += ` - `;
          }
          name +=`${this.model.articleNo}`;
        }
        return name;
      },
      bundles(){
        if(!this.model) return [];
        return this.model.bundles || [];
      }
    },

    methods: {
      init(){
        this.model = cloneDeep(this.item);
      },
      showKisoftTelegram(){
        if(!this.model || !this.model.id) throw new Error('Missing required id param');
        const id = this.model.id;
        this.$emit('showKisoftTelegram', id)
      },
      openItemPage(){
        if(!this.model || !this.model.id) throw new Error('Missing required id param');
        this.$router.push({ name: "item", params: { id: this.model.id } });
      }
    },

  }
</script>

<style lang="scss" scoped>
.item-row{
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #ccc;
  margin: .2em 0;
  color: #666666 !important;
  font-family: Arial, sans-serif!important;
  font-weight: 400!important;
  font-size: 14px!important;
  line-height: 16.1px!important;

  &__header{
    flex: 1;
    display: flex;
    position: relative;
    flex-wrap: wrap;
    justify-content: space-between;

    &--article{
      padding: .5em;
      display: flex;
      flex-wrap: wrap;
      font-weight: 600;
      &::v-deep .v-btn{
        flex-wrap: wrap;
        flex: 1;
        word-wrap: break-word;

      }
      & > *::v-deep .v-btn__content{
        flex-wrap: wrap;
        flex: 1 1 100%;
        word-break: break-all;
        white-space: normal;
      }
    }

    &--telegram{
      width: 30px;
      height: 30px;
      background-color: #1b99a7; 
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__body{
    flex: 2;
    display: block;
    position: relative;
    padding-bottom: .75em;
  }

}
</style>
